var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-mask',_vm._b({staticClass:"form-control",attrs:{"mask":"DE###########","value":_vm.value,"type":"text","masked":true,"tokens":_vm.vatTokens},on:{"input":_vm.onInput}},'the-mask',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }